(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/testmonial-slider"],{

/***/ "./src/assets/js/testmonial-slider.js":
/*!********************************************!*\
  !*** ./src/assets/js/testmonial-slider.js ***!
  \********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var TestimonialSlider = /*#__PURE__*/function (_HTMLElement) {
  function TestimonialSlider() {
    var _this;
    _classCallCheck(this, TestimonialSlider);
    _this = _callSuper(this, TestimonialSlider);
    _this.sliderTop = _this.querySelector('.testimonial-swiper-top');
    _this.sliderBottom = _this.querySelector('.testimonial-swiper-bottom');
    _this.bottomSlides = _this.sliderBottom.querySelectorAll('.swiper-slide');
    _this.topSlides = _this.sliderTop.querySelectorAll('.swiper-slide');
    _this.autoPlay = _this.dataset.autoplaytime;
    _this.autoSpeed = _this.dataset.autoplayspeed;
    _this.slidesPerView = 3;
    _this.totalSlidesRequired = _this.slidesPerView * 2;
    return _this;
  }
  _inherits(TestimonialSlider, _HTMLElement);
  return _createClass(TestimonialSlider, [{
    key: "rebuildSlider",
    value: function rebuildSlider(slides, slider, swiperWrapper) {
      if (slides.length < this.totalSlidesRequired) {
        if (slider) {
          slider.destroy(true, true);
        }
        var totalTopSlides = slides.length;
        var wrapper = swiperWrapper.querySelector('.swiper-wrapper');
        for (var i = 0; i < totalTopSlides; i++) {
          var clone = slides[i].cloneNode(true);
          wrapper.appendChild(clone);
        }
      }
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      var swiperOptions = {
        slidesPerView: 1.2,
        spaceBetween: 15,
        loop: true,
        autoplay: {
          delay: Number(this.autoPlay),
          disableOnInteraction: false
        },
        speed: Number(this.autoSpeed),
        allowTouchMove: true,
        touchRatio: 1,
        touchAngle: 45,
        breakpoints: {
          640: {
            slidesPerView: 2.5,
            spaceBetween: 15
          },
          768: {
            slidesPerView: 3.2,
            spaceBetween: 15
          },
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 15
          }
        }
      };
      if (this.topSlides.length < this.totalSlidesRequired) {
        this.rebuildSlider(this.topSlides, this.activeSliderTop, this.sliderTop);
      }
      this.activeSliderTop = new Swiper(this.sliderTop, _objectSpread({}, swiperOptions));
      if (this.bottomSlides.length < this.totalSlidesRequired) {
        this.rebuildSlider(this.bottomSlides, this.activeSliderBottom, this.sliderBottom);
      }
      this.activeSliderBottom = new Swiper(this.sliderBottom, _objectSpread(_objectSpread({}, swiperOptions), {}, {
        autoplay: {
          delay: Number(this.autoPlay),
          disableOnInteraction: false,
          reverseDirection: true
        }
      }));
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var checkSwiper = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          _this2.initSlider();
          clearInterval(checkSwiper);
        }
      }, 100);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('testimonial-slider')) {
  customElements.define('testimonial-slider', TestimonialSlider);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/testmonial-slider.js"));
/******/ }
]);